import {
  ProductAvailabilityTierToggleAllRequestType,
  ProductAvailabilityTierToggleAllResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductAvailabilityTierToggleAll = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductAvailabilityTierToggleAllRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `product-availability-tiers/toggle-all`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as ProductAvailabilityTierToggleAllResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.AvailabilityTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductAvailabilityTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductAssignment],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.AvailabilityTiers],
      });
    },
  });
};
